import classNames from 'classnames';
import styles from './styles.module.scss';

export const IconWTextBelow = (
  {
    className, bottom, text, Icon, SecondaryIcon, title, iconTitle,
  }:{
    className?: string,
    text: string | number,
    Icon?: React.FC<{ className?: string }>,
    SecondaryIcon?: React.FC<{ className?: string }>,
    bottom?: string,
    title?: string,
    iconTitle?: string,
  },
) => (
  <div className={classNames(styles.box, className)} title={title}>
    {Icon && (
      <div title={iconTitle}>
        <Icon className={styles.icon} />
      </div>
    )}
    {SecondaryIcon && <SecondaryIcon className={styles.secondaryIcon} />}
    <div>
      <div className={styles.value}>{text}</div>
      {bottom && <div className={styles.secondary}>{bottom}</div>}
    </div>
  </div>
);
